import React, { useState, useEffect } from 'react'
import { arrayOf, shape, func } from 'prop-types'
import {
  GROCERIES_SEARCH_URL,
  GEORGE_SEARCH_URL,
} from 'services/utility/constants'
import { isEmpty } from 'services/utility'
import Icon from 'common/components/icon'
import './index.scss'

const Search = ({
  searchRedirects: {
    sites,
  },
  searchRedirectsActions: {
    laodSearchRedirects,
  },
}) => {
  useEffect(() => {
    laodSearchRedirects()
  }, [laodSearchRedirects])
  const [term, setTerm] = useState('')
  const [site, setSite] = useState('groceries')
  const searchKeywordInRedirects = (sites, inputValue) => {
    let siteMatched = null
    if (!sites) return null
    sites.map((site) => {
      if (inputValue === site.toGHS) {
        siteMatched = { toGHS: inputValue }
      } else if (inputValue === site.toGeorge) {
        siteMatched = { toGeorge: inputValue }
      } else if (site.toOther && inputValue === site.toOther.otherKeyword) {
        siteMatched = site.toOther
      }
      return false
    })
    return siteMatched
  }
  const generateCmpId = (searchTerm, selectedSite, isRedirect, otherSiteTo) => {
    let cmpid = ''
    const path = window.location.pathname.split('/')
    const pageName = path[path.length - 1] || 'hp'
    const searchTermE = searchTerm.replace(/\s+/g, '-').toLowerCase()
    const searchTermR = isRedirect
      ? `search-redirect-${searchTermE}`
      : `search-${searchTermE}`
    if (selectedSite === 'groceries') {
      cmpid = `?cmpid=ahc-_-ghs-_-asdacom-_-${pageName}-_-${searchTermR}`
    } else if (selectedSite === 'george') {
      cmpid = `&cmpid=ahc-_-geor-_-asdacom-_-${pageName}-_-${searchTermR}`
    } else {
      cmpid = `?cmpid=ahc-_-${otherSiteTo}-_-asdacom-_-${pageName}-_-${searchTermR}`
    }
    return cmpid
  }
  const submit = (localSite, localTerm) => {
    if (!localTerm.trim()) return false
    let url = null
    const siteMatched = searchKeywordInRedirects(sites, localTerm) || {}
    const {
      toGHS,
      toGeorge,
      otherKeyword,
      otherSiteTo,
      otherLink,
    } = siteMatched
    const groceriesUrl = `${GROCERIES_SEARCH_URL}${localTerm}`
    const georgeUrl = `${GEORGE_SEARCH_URL}${localTerm}`
    const noRedirect = isEmpty(siteMatched)
    if (noRedirect) {
      url = localSite === 'groceries' ? groceriesUrl : georgeUrl
      url += generateCmpId(localTerm, localSite, false)
    } else if (toGHS) {
      url = groceriesUrl + generateCmpId(localTerm, 'groceries', true)
    } else if (toGeorge) {
      url = georgeUrl + generateCmpId(localTerm, 'george', true)
    } else if (otherKeyword) {
      url = otherLink + generateCmpId(localTerm, 'other', true, otherSiteTo)
    }
    window.location = url
    return null
  }
  return (
    <form
      className="search-box"
      onSubmit={(e) => {
        e.preventDefault()
        submit(site, term)
      }}
    >
      <input
        type="search"
        className="search-input"
        value={term}
        onChange={e => setTerm(e.target.value)}
        placeholder="Search for..."
      />
      <select
        className="search-select"
        value={site}
        onChange={e => setSite(e.target.value)}
      >
        <option value="groceries">in Groceries</option>
        <option value="george">in George</option>
      </select>
      <button
        className="search-button"
        onClick={(e) => {
          e.preventDefault()
          submit(site, term)
        }}
        type="submit"
      >
        <Icon name="search" color="white" />
      </button>
    </form>
  )
}

Search.propTypes = {
  searchRedirects: shape({
    sites: arrayOf(shape()),
  }),
  searchRedirectsActions: shape({
    laodSearchRedirects: func,
  }),
}

Search.defaultProps = {
  searchRedirects: {
    sites: [],
  },
  searchRedirectsActions: {
    laodSearchRedirects: x => x,
  },
}

export default Search



// WEBPACK FOOTER //
// ./components/search/index.js